import { Action } from 'redux-actions';
import { ImmutableObject, isImmutable } from 'seamless-immutable';

import * as actions from './actions';
import { searchParamsToObject } from '@core-ui/url';

export default <State extends ImmutableObject<unknown>>(reducerName: string): {
  [actionType: string]: (state: State, action: Action<any>) => ImmutableObject<unknown>
} => ({
  [actions.setDataFromSearchParams(reducerName).toString()]: (state) => {
    if (!isImmutable(state)) {
      return state;
    }
    let newState = state;
    const searchParams = searchParamsToObject(window.location.search, {
      ignoreQueryPrefix: true,
      convertStrings: true,
    });
    // eslint-disable-next-line no-restricted-syntax
    for (const key in searchParams) {
      // eslint-disable-next-line no-prototype-builtins
      if (newState.hasOwnProperty(key) && searchParams.hasOwnProperty(key)) {
        // @ts-ignore
        newState = newState.set([key], searchParams[key]);
      }
    }
    return newState;
  },
  [actions.setFieldFilter(reducerName).toString()]: (state, { payload }) => {
    if (!isImmutable(state) || !payload) {
      return state;
    }

    const { field, value } = payload;
    return state.merge({
      [field]: value,
    });
  },
  [actions.setDateFieldFilter(reducerName).toString()]: (state, { payload }) => {
    if (!isImmutable(state) || !payload) {
      return state;
    }
    return state.merge({
      ...payload,
      page: 1,
    });
  },
  [actions.setPeriodFieldFilter(reducerName).toString()]: (state, { payload }) => {
    if (!isImmutable(state) || !payload) {
      return state;
    }

    return state.merge({
      period: payload,
      page: 1,
    });
  },
});
